import { Injectable } from '@angular/core';
import { AppConfigService } from '../appConfig/appConfigService';
import { TimberService } from '@logging/timber.service';
import { initialize } from '@itero/itero-open-telemetry';
import { FeaturesToggleSettingsService } from '../../featuresToggleSettings/service/featuresToggleSettings.service';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';
import { ShellContextService } from '../shell-context/shell-context.service';
import { FeatureToggle } from '@shared/enums';
@Injectable({
	providedIn: 'root',
})
export class AppTelemetryService {
	// Make the initialize function a property that can be mocked in tests
	private initializeFn = initialize;
	private telemetrySubscription: Subscription;

	constructor(
		private appConfigService: AppConfigService,
		private timberService: TimberService,
		private featuresToggleSettingsService: FeaturesToggleSettingsService,
		private shellContextService: ShellContextService
	) { }

	async initialize(): Promise<void> {

		const serviceName = this.appConfigService.appSettings.OtelCollectoreConfig.Appname;
		const signalFxUrl = this.appConfigService.appSettings.OtelCollectoreConfig.Endpoint;

		this.telemetrySubscription = combineLatest([
			this.featuresToggleSettingsService.getFeaturesToggleSettings().pipe(take(1)),
			this.shellContextService.getContext().pipe(
				distinctUntilChanged((prev, curr) => prev.security.accessToken === curr.security.accessToken),
				filter((shellContext) => !!shellContext.security.accessToken)
			),
		]).subscribe(async ([featureToggles, shellContext]) => {
			const appTelemetryFeature = featureToggles.some(
				(f) => f?.id === FeatureToggle?.OpenTelemetryFeatureFlag && f?.isActive === true
			);

			if (appTelemetryFeature) {
				try {
					await this.initializeFn(serviceName, signalFxUrl, shellContext.security.accessToken, shellContext.session.sessionId);
				} catch (error) {
					this.timberService.error('Unexpected error in initialize()', {
						error,
						module: 'AppTelemetryService',
					});
				}
			}
		});
	}
}
